<template>
  <PopupForm
    title="Show Label"
    button="Show"
    :show="show"
    @close="emit('close')"
    @confirm="showLabel()"
  >
    <div class="input-group col-span-12 sm:col-span-4 mb-4">
      <select
        v-model="form.mode"
        name="mode"
      >
        <option :value="null">Select Code Type</option>
        <template v-for="(label, key) in modes">
          <option :value="key">
            {{ label }}
          </option>
        </template>
      </select>
    </div>

    <div class="grid grid-cols-12 gap-4 py-3 items-center">
      <div
        class="text-left flex flex-col leading-tight"
        :class="{ 'col-span-6': usesSubLot, 'col-span-10': !usesSubLot }"
      >
        <span
          class="uppercase font-semibold text-sm"
          :class="{ 'text-red-600': false, 'text-blue-600': true }"
        >
          {{ getPackageName() || '' }}
        </span>
        <span class="text-gray-600 text-sm font-semibold">
          {{ getPackageBatch() || '' }}
        </span>
      </div>
      <div
        v-if="usesSubLot"
        class="input-group col-span-4"
      >
        <select
          v-model="form.sub_lot_num"
          name="sub_lot_num"
        >
          <option :value="null">Select Sub-Lot</option>
          <template v-for="(label, key) in subLotOptionsForPackage()">
            <option :value="label">
              {{ label }}
            </option>
          </template>
        </select>
      </div>
    </div>
  </PopupForm>
</template>

<script setup>
import { ref, watch, computed } from 'vue'
import { useForm, router } from '@inertiajs/vue3'
import PopupForm from '@/Components/Forms/PopupForm'
import { getHeadersWithToken } from '@/utils/http'

const emit = defineEmits(['close'])

const props = defineProps({
  show: {
    type: Boolean,
    default: false
  },
  package: {
    type: Object,
    required: true
  },
  /**
   * A list of print modes for label.
   */
  modes: {
    type: Array,
    default: () => []
  }
})

const form = useForm({
  mode: null,
  sub_lot_num: null
})

const subLotNums = ref({})

const usesSubLot = computed(() => {
  return ['sub_lot', 'tag_and_sub_lot'].includes(form.mode)
})

watch(usesSubLot, (newVal) => {
  console.log('usesSubLot', newVal)
  if (newVal) {
    getSubLotsForPackage()
  }
})

async function getSubLotsForPackage() {
  const response = await fetch(route('api.packages.sub_lot_options', { packages: [props.package.id] }), {
    headers: getHeadersWithToken(),
    method: 'get'
  })

  subLotNums.value = await response.json()
}

const getPackageName = () => {
  return props.package.name || props.package.details?.name || null
}
const getPackageBatch = () => {
  return props.package.batch_num || props.package.details?.batch_num || null
}

const subLotOptionsForPackage = () => {
  return subLotNums.value[props.package.id] || []
}

const showLabel = () => {
  window.open(route('packages.label', { package: props.package.id, ...form.data() }), '_blank')
}

const getErrors = (field) => {
  let errors = form.errors || {}
  return field in errors ? errors[field] : ''
}
</script>
